function standardsPageLoaded() {
	
	var standardsVideos = jQuery('iframe.background-video.fade-on-pause'),
		firstVideoSlide = true;

	function videoStartedPlaying() { videoLoaded = true; }
	jQuery('#diningroom-video').on("play", videoStartedPlaying);
	jQuery('#lounge-video').on("play", videoStartedPlaying);
	jQuery('#cinema-video').on("play", videoStartedPlaying);
	jQuery('#gamesroom-video').on("play", videoStartedPlaying);
	jQuery('#studyroom-video').on("play", videoStartedPlaying);
	jQuery('#gym-video').on("play", videoStartedPlaying);
	jQuery('#bedroom-video').on("play", videoStartedPlaying);
	jQuery('#kitchen-video').on("play", videoStartedPlaying);
	standardsVideos.vimeo('play');
	standardsVideos.vimeo('pause');

	jQuery(window).load(function() { 

		if (jQuery(window).width() >= 768) {

			jQuery.scrollify({
				section : "section, footer",
				before: beforeScroll,
				after: afterScroll
			});

			function beforeScroll(section_index, sections) {

				var index = section_index - 2;
				var prevVideo = jQuery(standardsVideos[index]);

				if (prevVideo.length > 0) {
					prevVideo.vimeo('pause');
				}
			}

			function afterScroll(section_index, sections) {

				jQuery('.sections-nav a').removeClass('active');
				jQuery('#section-nav-' + (section_index+1)).addClass('active');

				var index = section_index - 1;
				var nextVideo = jQuery(standardsVideos[index]);

				if (nextVideo.length > 0) {
					console.log(firstVideoSlide);

					if (firstVideoSlide) {
						setTimeout(function() {
							if (!videoLoaded) { hideVideos(standardsVideos, {fadeOut: true}); }
						}, maxTimeForLoad);
					}
					firstVideoSlide = false;

					nextVideo.vimeo('play');

				}
			}
		}
		
		loading_screen.finish();

		jQuery('.scroll-down').delay(2000).fadeTo('600', 1).addClass('animate');
		jQuery('.sections-nav').delay(2000).fadeTo('1000', 1);
	});

	jQuery(standardsVideos).on('finish', function() {
		hideVideos(this, {fadeOut: true});
		jQuery(this).siblings('.overlay').fadeTo(500, 1);
		jQuery(this).siblings('.black-card').remove();
	});

	jQuery('.hamburger-menu').on('click', function() {

		if (jQuery.scrollify.isDisabled()) {
			jQuery.scrollify.enable();
		} else {
			jQuery.scrollify.disable();
		}
	});
}